var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image-group",attrs:{"role":"group"}},[_c('img',{staticClass:"image-icon",attrs:{"src":require('@/assets/' + _vm.image),"title":_vm.title}}),(!_vm.noSubtitle)?_c('figcaption',{staticClass:"image-subtitle"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }